
// Definición de defaults

export const defaultRol: RolProps = {
    idRol:          0,
    nombre:         '',
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface RolProps {
    idRol:          number;
    nombre:         string;
    descripcion:    string;
    activo:         boolean;
}